import ReducerRegistry from "../base/redux/ReducerRegistry";
import { SET_FLIP } from "./actionTypes";
const initialState = {
    participantIds: []
};
const flipReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FLIP:
            return {
                participantIds: action.payload.participantIds
            };
        default:
            return state;
    }
};
ReducerRegistry.register("features/flip", flipReducer);
